import React, { useCallback, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import logo from "../../image/ayekart logo.png";
import Loader from "../Loader";
import axios from "axios";
import { Box, ListItemIcon, Popover } from "@mui/material";
import "../../FinanceGridView.css";
import axisBankLogo from "../../image/axis-logo.png";
import IciciODLogo from "../../image/ICICIOD.png";
import iciciBankLogo from "../../image/icici_bank_logo1.png";
import iciciH2H from "../../Assets/Images/Group 151.png";
import axish2h from "../../Assets/Images/axis-h2h.png";
import janaBankLogo from "../../Assets/Images/jfb-logo.webp";
import rblLogo from "../../Assets/Images/rbl-bank-logo.png";
import sbiLogo from "../../image/sbi-logo.png";
import { width } from "@mui/system";
import moment from "moment";
import { Button, Modal, Typography } from "@material-ui/core";
import Select from "react-select";
import { restrictedUser } from "../../utils";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

function AyekartAgroFinanceGridView() {
  const location = useLocation();
  const params = useParams();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [loading, setLoading] = useState(false);
  const [gridOrders, setGridOrders] = useState([]);
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [paidSubmitFlag, setPaidSubmitFlag] = useState(false);
  const [toGetUpdatedList, setTogetUpdatedList] = useState(false);
  const [gridStatus, setGridStatus] = useState("");
  const [workflowApprovalStatus, setWorkflowApprovalStatus] = useState("");
  const [allOrdersTotal, setAllOrdersTotal] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [formObj, setFormObj] = useState([]);
  const [selectedOrdersTotal, setSelectedOrdersTotal] = useState(0);
  const [downloadSheetFlag, setDownloadSheetFlag] = useState(false);
  const [dateForPaid, setDateForPaid] = useState();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const todaysDate = new Date()?.toISOString();
  const [openModal, setOpenModal] = React.useState(false);
  const [modalMessage, setModalMessage] = React.useState("");
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const history = useNavigate();
  const isAgro = 1;
  const isRetail = location?.state?.org_id === 2;
  const isFintech = location?.state?.org_id === 3;
  const [gridComment, setGridComment] = useState([]);
  const [banks, setBanks] = useState([]);
  const [currentGridId, setCurrentGridId] = useState(
    location?.state?.id ?? location?.state
  );
  const [gridPage, setGridPage] = useState(location?.state?.gridPage || 1);
  const [totalGrids] = useState(location?.state?.totalGrids || 0);
  const [activeTab] = useState(location?.state?.activeTab ?? 0);
  const [searchQuery] = useState(location?.state?.searchQuery || "");

  const gridId = currentGridId ?? location?.state?.id ?? location?.state;
  const tabNames = ["Pending", "Approved", "Paid", "Rejected"];

  const resetGridViewState = () => {
    setMarkAsPaid(false);
    setPaidSubmitFlag(false);
    setSelectAll(false);
    setSelectedOrdersTotal(0);
    setDownloadSheetFlag(false);
    setIsSubmitDisabled(false);
    setDateForPaid(undefined);
  };

  const fetchGridAtPage = async (targetPage) => {
    if (targetPage < 1 || (totalGrids > 0 && targetPage > totalGrids)) return;

    setLoading(true);
    const token = localStorage.getItem("token");
    const selectedTab = tabNames[activeTab] || "Pending";

    try {
      const response = await fetch(
        `/workflow/api/orders/grids?org_id=1&tab_name=${selectedTab}&page=${targetPage}&limit=1${
          searchQuery ? `&id=${searchQuery}` : ""
        }`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();

      if (data?.status && data?.grids?.length > 0) {
        const newGridId = data.grids[0].id;
        resetGridViewState();
        setCurrentGridId(newGridId);
        setGridPage(targetPage);
        history(location.pathname, {
          replace: true,
          state: {
            ...location.state,
            id: newGridId,
            gridPage: targetPage,
            activeTab,
            totalGrids,
            searchQuery,
          },
        });
      } else {
        toast.error("No grid found");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch grid");
      setLoading(false);
    }
  };

  const handlePreviousGrid = () => {
    if (gridPage > 1) fetchGridAtPage(gridPage - 1);
  };

  const handleNextGrid = () => {
    if (totalGrids === 0 || gridPage < totalGrids) fetchGridAtPage(gridPage + 1);
  };

  // useEffect(() => {
  //   if (userDetails?.user_category !== "Finance") {
  //     toast.error("Access denied");
  //     return history("/bulkorder");
  //   }
  // }, []);
  //-------------------------------------------------

  const getBanks = async () => {
    try {
      setLoading(true);
      const orgId = 1;
      const response = await axios.get(
        `/workflow/api/org-wise-bank-details?org_id=${orgId}`
      );
      if (response.data?.status) {
        setBanks(response.data.data);
      } else {
        setBanks([]);
      }
    } catch (err) {
      setBanks([]);
    } finally {
      setLoading(false);
    }
  };

  const getFinanceBankUrl = useCallback(
    (bank) => {
      let org = isAgro
        ? "finance_agro"
        : isRetail
        ? "finance_retail"
        : "finance";

      return `/workflow/api/${gridId}/${org}?bank=${bank}`;
    },
    [gridId, isAgro, isRetail]
  );

  const getPrefixForFileName = useCallback(
    () => (isAgro ? "AGRO" : isRetail ? "RETAIL" : "FINTECH"),
    [isAgro, isFintech, isRetail]
  );

  const getTableData = () => {
    if (!gridId) return;
    const token = localStorage.getItem("token");
    setLoading(true);
    setDownloadSheetFlag(false);
    fetch(
      `/workflow/api/${gridId}/orders`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.grid_status === "Paid") {
          setDownloadSheetFlag(true);
        }
        let temp = [];
        let sum = 0;
        res?.orders.map((item, index) => {
          if (item?.grid_status === "Paid") {
            setDownloadSheetFlag(true);
          }
          if (!isNaN(item?.amount_to_be_paid_net_off_tds)) {
            sum = sum + Number(item?.amount_to_be_paid_net_off_tds);
          }
          temp.push({
            order_id: item?.order_id,
            order_flag: item?.grid_status === "Paid" ? true : false,
          });
        });
        setStatusArray(temp);
        setAllOrdersTotal(sum);
        let tempAmount_PaidObj = res?.orders?.map((item, ind) => {
          return {
            ...item,
            amount_paid: item?.total_payable,
          };
        });

        setGridOrders(tempAmount_PaidObj);
        setGridComment(res?.grid_comment || "");
        setGridStatus(res?.grid_status);
        setWorkflowApprovalStatus(res?.workflow_approval_status);
        if (res?.grid_status === "Paid") {
          setSelectedOrdersTotal(sum);
        }
        setLoading(false);
      });
  };
  useEffect(() => {
    getTableData();
  }, [toGetUpdatedList, currentGridId]);

  const onchangeHandlerForAmount = (e, ele, ind) => {
    let temp = gridOrders;
    let a = temp?.map((item, index) => {
      if (ind === index) {
        return {
          ...item,
          amount_paid: e.target.value,
        };
      }
    });
    setGridOrders(a);
  };

  const submitMarkAsPaid = () => {
    setIsSubmitDisabled(true);
    let temp = statusArray;
    let tempArray = [];
    temp.map((item, index) => {
      if (item?.order_flag === true) {
        tempArray.push(item?.order_id);
      }
    });

    let finalTemp = [];
    // gridOrders.map((item, index) => {
    //   if (tempArray.includes(item?.order_id)) {
    //     console.log(item);
    //     const checkbox = document.getElementById(`checkbox-${index}`);

    //     if (checkbox.checked && !checkbox.disabled) {
    //       finalTemp.push({
    //         id: item?.order_id,
    //         amount_paid: item?.amount_paid,
    //         total_cp: item?.total_payable_net_off_tds,
    //         date: dateForPaid,
    //       });
    //     }
    //   }
    // });

    for (let index = 0; index < gridOrders.length; index++) {
      const item = gridOrders[index];

      if (tempArray.includes(item?.order_id)) {
        const checkbox = document.getElementById(`checkbox-${index}`);

        if (checkbox.checked && !checkbox.disabled) {
          // if (!item?.utr) {
          //   toast.error(`UTR is missing for order ID: ${item?.order_id}`);
          //   setIsSubmitDisabled(false);
          //   return; // stop further execution
          // }
          // if (!item?.utr || item.utr.length < 12 || item.utr.length > 22) {
          //   toast.error(`UTR is invalid for order ID: ${item?.order_id}`);
          //   setIsSubmitDisabled(false);
          //   return; // stop further execution
          // }
          // if (!item?.selected_bank) {
          //   toast.error(`Bank is not selected for order ID: ${item?.order_id}`);
          //   setIsSubmitDisabled(false);
          //   return; // stop further execution
          // }

          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.amount_paid,
            total_cp: item?.total_payable_net_off_tds,
            date: dateForPaid,
            utr: item?.utr,
            bank: item?.bank || "",
            account_number: item?.account_number || "",
            ifsc_code: item?.ifsc_code || "",
            branch_name: item?.branch_name || "",
            bank_type: item?.bank_type || "",
            org_name: item?.org_name || "",
            org_id: item?.org_id || "",
          });
        }
      }
    }

    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const payload = {
      orders: finalTemp,
      grid_status:
        gridOrders?.length === finalTemp?.length ? "Paid" : "Pending",
      actioner: userDetails?.user_name
        ? userDetails?.user_name
        : userDetails?.user_category,
    };

    if (dateForPaid <= todaysDate) {
      setLoading(true);
      setIsSubmitDisabled(false);
      axios
        .put(
          `/workflow/api/grid/${
            gridId
          }/paid`,
          payload,
          config
        )
        .then((data) => {
          if (data?.data?.status) {
            setLoading(false);
            toast.success(data?.data?.message);
            setPaidSubmitFlag(true);
            history("/ayekart-agro/finance-grids", {
              state: { activeTab: 2 },
            });
          } else {
            toast.error(data?.data?.message);
            setLoading(false);
          }
          setPaidSubmitFlag(false);
        });
    } else {
      setIsSubmitDisabled(false);
      if (dateForPaid > todaysDate)
        toast.error("Date should not be future date");
      if (!dateForPaid) {
        toast.error("Plese select date");
      }
    }
  };

  const currentDate = new Date()?.toISOString();
  const cancelGrid = () => {
    if (window.confirm("Do you really want to cancel this Grid?")) {
      setLoading(true);
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      // Create an array with all the required fields
      const cancelGridOrders = gridOrders.map((item) => ({
        id: item?.order_id,
        amount_paid: item?.amount_paid,
        total_cp: item?.total_payable_net_off_tds,
        date: dateForPaid,
      }));

      const payload = {
        orders: cancelGridOrders,
        grid_status: "Rejected",
        rejection_stamp: `${currentDate}`,
        actioner: userDetails?.user_name
          ? userDetails?.user_name
          : userDetails?.user_category,
        actioner_id: userDetails?.id ? userDetails?.id : userDetails?.id,
      };
      axios
        .put(
          `/workflow/api/grid/${
            gridId
          }/paid`,
          payload,
          config
        )
        .then((data) => {
          if (data?.data?.status) {
            toast.success("Grid has been cancelled");
            setTimeout(function () {
              history("/ayekart-agro/finance-grids", {
                state: { activeTab: 3 },
              });
            }, 1000);
          } else {
            setLoading(false);
            toast.error(data?.data?.message);
          }
        });
    }
  };

  // const getCSVForSBI = () => {
  //   const token = localStorage.getItem("token");
  //   const config = {
  //     headers: { Authorization: `Bearer ${token}` },
  //   };
  //   let temp = statusArray;
  //   let tempArray = [];
  //   temp.forEach((item, index) => {
  //     if (item?.order_flag === true ) {
  //       const checkbox = document.getElementById(`checkbox-${index}`);
  //       if (checkbox.checked && !checkbox.disabled) {
  //         tempArray.push(item?.order_id);
  //       }
  //     }
  //   });
  //   const payload = {
  //     orders_id: tempArray,
  //   };
  //   axios
  //     .put(
  //       `/workflow/api/${
  //         gridId
  //       }/finance?bank=sbi`,
  //       payload,
  //       {
  //         responseType: "arraybuffer",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       const type = response.headers["content-type"];
  //       const blob = new Blob([response.data], {
  //         type: type,
  //         encoding: "UTF-8",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `SBI_${moment(new Date()).format("DD-MM-YYYY")}_Grid-${
  //         gridId
  //       }.xlsx`;
  //       link.click();
  //     });
  // };

  const getCSVForIcici = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    if (!tempArray || tempArray.length === 0) {
      toast.error("Please select at least one order.");
      return;
    }
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("icici");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_ICICI_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          gridId
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForJana = () => {
    const token = localStorage.getItem("token");
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    if (!tempArray || tempArray.length === 0) {
      toast.error("Please select at least one order.");
      return;
    }
    const payload = {
      order_ids: tempArray?.map((item) => ( {
        "order_id": item,
        "shop_branch_id": null
    })),
     "h2h_actioner":  userDetails?.user_name ? userDetails?.user_name : userDetails?.user_category,
    };
    const url =  `/axis/collections/retail_jana_excel_encryption_with_branch_id/${
      gridId
    }?bank=jana&sheet_type=external&is_excel_required=true`;
    // axios
    //   .post(url, payload)
    //   .then((response) => {
    //     const type = response.headers["content-type"];
    //     const blob = new Blob([response.data], {
    //       type: type,
    //       encoding: "UTF-8",
    //     });
    //     const link = document.createElement("a");
    //     link.href = window.URL.createObjectURL(blob);
    //     link.download = `${getPrefixForFileName()}_JANA_${moment(
    //       new Date()
    //     ).format("DD-MM-YYYY")}_Grid-${
    //       gridId
    //     }.xlsx`;
    //     link.click();
    //   }).catch((error) => {
    //     console.log(error);
    //     toast.error("Something Went Wrong");
    //   });
    axios
  .post(url, payload)
  .then((response) => {
    // assuming API returns: { status: true, link: "https://..." }
    const fileUrl = response?.data?.link;

    if (!fileUrl) {
      toast.error("File URL not found");
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `${getPrefixForFileName()}_JANA_${moment(
      new Date()
    ).format("DD-MM-YYYY")}_Grid-${
      gridId
    }.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
  .catch((error) => {
    console.log(error);
    toast.error("Something Went Wrong");
  });

  };

  const getCSVForRbl = () => {
    const token = localStorage.getItem("token");
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("rbl");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_RBL_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          gridId
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForAxis = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("axis");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_AXIS_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          gridId
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForICICIOD = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("icici_od");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_ICICIOD_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          gridId
        }.xlsx`;
        link.click();
      });
  };

  const getForICICIH2H = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
      h2h_actioner: `${userDetails?.user_name}`,
      h2h_bank: "icici",
    };
    setLoading(true);
    let url = "";
    if (isAgro) {
      url = `/workflow/api/finance/h2h_agro/${
        gridId
      }?bank=icici`;
    } else {
      return;
    }
    axios
      .post(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLoading(false);
        setModalMessage(
          "The file has been successfully sent to ICICI host to host path. Kindly login to netbanking and authorize the payment. Once the payment is done please mark this payment as 'Paid'."
        );
        handleOpenModal();
        getTableData();
        setSelectAll(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something Went Wrong");
      });
  };

  const getForAxisH2H = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true) {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
      h2h_actioner: `${userDetails?.user_name}`,
    };
    setLoading(true);
    axios
      .post(
        `/axis/collections/axis/finance_sheet/${
          gridId
        }`,
        payload,
        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setModalMessage(
          "The file has been successfully sent to Axis host to host path. Kindly login to netbanking and authorize the payment. Once the payment is done please mark this payment as 'Paid'."
        );
        handleOpenModal();
        getTableData();
        setSelectAll(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something Went Wrong");
      });
  };

  const changeStatusInStatusArray = (e, ind) => {
    let temp = statusArray;
    temp.map((item, tempIndex) => {
      if (tempIndex === ind) {
        if (e.target.checked) {
          temp[tempIndex].order_flag = e.target.checked;
        } else {
          temp[tempIndex].order_flag = e.target.checked;
        }
      }
    });
    let tempTotal = 0;
    temp?.map((item, index) => {
      if (item?.order_flag === true) {
        tempTotal =
          tempTotal + Number(gridOrders[index].amount_to_be_paid_net_off_tds);
      }
    });
    setSelectedOrdersTotal(tempTotal);
    setStatusArray(temp);
    setDummy(e.target.checked);
  };

  const selectAllFun = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedOrdersTotal(allOrdersTotal);
      let temp = statusArray;
      temp.map((item, index) => {
        if (gridOrders[index]?.grid_status === "Paid") {
          temp[index].order_flag = false;
        } else {
          temp[index].order_flag = true;
        }
      });
      setStatusArray(temp);
    } else {
      let temp = statusArray;
      temp.map((item, index) => {
        temp[index].order_flag = false;
      });
      setStatusArray(temp);
      setSelectedOrdersTotal(0);
    }
  };

  useEffect(() => {
    getBanks();
  }, []);

  return (
    <div className="">
      <div className="mt-3  ">
        <Loader loading={loading} />
        <div className="container-fluid ">
          <span
            className="text-primary fs-6 font-semibold"
            onClick={() =>
              history("/ayekart-agro/finance-grids", {
                state: { activeTab: location?.state?.activeTab },
              })
            }
            style={{ cursor: "pointer" }}
          >
            {`<< Back`}
          </span>
        </div>
        <div className="container-fluid mt-3 p-0">
          <div
            className="border rounded-md  px-0"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="row mx-0">
              <div className="col-12 p-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={handlePreviousGrid}
                    disabled={gridPage <= 1 || loading}
                  >
                    Previous Grid
                  </button>
                  <span
                    className="fs-5 font-semibold"
                    style={{ color: "#042e74" }}
                  >
                    Grid No. &nbsp;
                    <span
                      style={{
                        fontWeight: 499,
                        backgroundColor: "#E5E7EB",
                        padding: "2px 5px",
                        borderRadius: "5px",
                      }}
                    >
                      {gridId}
                    </span>
                  </span>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={handleNextGrid}
                    disabled={
                      loading || (totalGrids > 0 && gridPage >= totalGrids)
                    }
                  >
                    Next Grid
                  </button>
                  {totalGrids > 0 && (
                    <span className="text-muted small ms-1">
                      ({gridPage} of {totalGrids})
                    </span>
                  )}
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <h5
                      className="fs-5 font-semibold"
                      style={{ color: "#042e74" }}
                    >
                      Total CP :&nbsp;
                    </h5>
                    <h4
                      className="fs-5"
                      style={{
                        color: "#0E9F6E",
                        backgroundColor: "#DEF7EC",
                        padding: "2px 5px",
                        borderRadius: "5px",
                      }}
                    >
                      ₹ {Number(allOrdersTotal).toFixed(2)}{" "}
                    </h4>
                  </div>
                </div>
              </div>
              <div
                className="col-12"
                style={{ border: "1px solid #E5E7EB" }}
              ></div>
              <div className="col col-sm-12 col-md-12 col-lg-12 p-2">
                <div className="container-fluid text-center mt-2">
                  <div className="row d-flex mx-0 justify-content-end mt-2 pb-0 mb-3">
                    <div className="col-6 text-left px-0">
                      <div className="d-flex flex-column">
                        <h5>
                          <span
                            className="fs-5 font-semibold"
                            style={{ color: "#042e74" }}
                          >
                            Selected Amount:&nbsp;
                          </span>
                          {"₹ "}
                          {Number(selectedOrdersTotal).toFixed(2)}{" "}
                        </h5>
                      </div>
                    </div>
                    <div className="col-6 text-left px-0">
                      <div className=" d-flex flex-column justify-content-start align-items-start p-2">
                        <label
                          className="form-label fw-bold"
                          style={{ color: "#042e74" }}
                        >
                          Grid Comment
                        </label>
                        <div className="p-2 border rounded bg-light w-100">
                          {gridComment || "Grid Comment Not Available"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mx-0 mt-2 py-2 mb-3">
                    <div className="col-12 d-flex flex-wrap gap-2 px-0">
                      {isAgro ? (
                        <div
                          className="card shadow-md text-center"
                          style={{ width: "125px", minHeight: "60px" }}
                        >
                          {downloadSheetFlag === true ? (
                            <button
                              className="btn btn-outline-light w-100 h-100"
                              onClick={() => getCSVForIcici()}
                            >
                              <img
                                src={iciciBankLogo}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-light h-100 w-100"
                              onClick={() => getCSVForIcici()}
                            >
                              <img
                                src={iciciBankLogo}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          )}
                        </div>
                      ) : null}
                      {isAgro ? (
                        <div
                          className="card shadow-md text-center"
                          style={{ width: "125px", minHeight: "60px" }}
                        >
                          {downloadSheetFlag === true ? (
                            <button
                              className="btn btn-outline-light w-100 h-100"
                              onClick={() => getCSVForJana()}
                            >
                              <img
                                src={janaBankLogo}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-light h-100 w-100"
                              onClick={() => getCSVForJana()}
                            >
                              <img
                                src={janaBankLogo}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          )}
                        </div>
                      ) : null}
                      {isAgro && workflowApprovalStatus === "Approved" ? (
                        <div
                          className="card shadow-md text-center"
                          style={{ width: "125px", minHeight: "60px" }}
                        >
                          {downloadSheetFlag === true ? (
                            <button
                              className="btn btn-outline-light w-100 h-100"
                              onClick={() => getForICICIH2H()}
                              disabled={restrictedUser()}
                            >
                              <img
                                src={iciciH2H}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-light h-100 w-100"
                              onClick={() => getForICICIH2H()}
                              disabled={restrictedUser()}
                            >
                              <img
                                src={iciciH2H}
                                alt=""
                                className="img-fluid"
                              />
                            </button>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-12 overflow-auto"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="table-responsive rounded-md overflow-auto"
                        style={{ maxHeight: "400px" }}
                      >
                        <table className="table ">
                          <thead
                            className="position-sticky top-0"
                            style={{ backgroundColor: "#e2e8f0" }}
                          >
                            <tr>
                              <th className="text-center text-blue-900">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectAll}
                                  onChange={(e) => {
                                    setDummy(e.target.checked);
                                    selectAllFun(e);
                                  }}
                                  disabled={gridStatus === "Paid"}
                                />
                                <br />
                                Order ID
                              </th>
                              <th className="text-blue-900">
                                Supplier Shop Name
                              </th>
                              <th className="text-blue-900">UTR</th>
                              <th className="text-blue-900">Bank Details</th>
                              <th className="text-blue-900">Total CP(₹)</th>
                              <th className="text-blue-900">
                                Total Payable(₹)
                              </th>
                              <th className="text-blue-900">TDS(₹)</th>
                              <th className="text-blue-900">Net Off TDS(₹)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {gridOrders?.length > 0 ? (
                              gridOrders.map((item, index) => (
                                <tr key={index}>
                                  <td className="text-center align-middle">
                                    <div className="d-flex flex-column align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input mb-1 position-relative"
                                        id={`checkbox-${index}`}
                                        checked={statusArray[index]?.order_flag}
                                        disabled={item?.grid_status === "Paid"}
                                        onChange={(e) => {
                                          changeStatusInStatusArray(e, index);
                                          setDummy(!dummy);
                                        }}
                                      />
                                      <span>{item?.order_id}</span>
                                      {item?.h2h_flag && (
                                        <span className="fw-bold text-success small mt-1">
                                          Sent for H2H{" "}
                                          {item?.h2h_bank &&
                                            `(${item?.h2h_bank})`}
                                        </span>
                                      )}
                                    </div>
                                  </td>

                                  <td>{item?.supplier_shop_name}</td>
                                  <td>
                                    <input
                                      readOnly={
                                        !(
                                          gridStatus !== "Rejected" &&
                                          gridStatus !== "Paid" &&
                                          workflowApprovalStatus === "Approved"
                                        )
                                      }
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter UTR"
                                      value={item.utr || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const isValid = /^[A-Z0-9]{0,22}$/.test(
                                          value
                                        ); // Alphanumeric, max 22
                                        const updatedOrders = [...gridOrders];
                                        updatedOrders[index].utr = value;
                                        updatedOrders[index].utrError =
                                          value.length > 0 &&
                                          (value.length < 12 || !isValid);
                                        setGridOrders(updatedOrders);
                                      }}
                                      onKeyPress={(e) => {
                                        const allowed = /^[a-zA-Z0-9]$/;
                                        if (!allowed.test(e.key)) {
                                          e.preventDefault(); // Block special chars & spaces
                                        }
                                      }}
                                      maxLength={22}
                                      minLength={12}
                                      style={{
                                        minHeight: "36px",
                                        fontSize: "14px",
                                        padding: "4px 8px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                        border: "1px solid gray",
                                      }}
                                    />
                                  </td>
                                  <td style={{ minWidth: "300px" }}>
                                    {!(
                                      gridStatus !== "Rejected" &&
                                      gridStatus !== "Paid" &&
                                      workflowApprovalStatus === "Approved"
                                    ) ||
                                    item?.grid_status === "Partially Paid" ? (
                                      <span>
                                        {item?.ayekart_bank_details_jsonb
                                          ? `${
                                              item?.ayekart_bank_details_jsonb?.bank
                                            } - A/C: ${
                                              item?.ayekart_bank_details_jsonb?.account_number ||
                                              "N/A"
                                            }`
                                          : "N/A"}
                                      </span>
                                    ) : (
                                      <Select
                                        isDisabled={
                                          item?.grid_status === "Paid"
                                        }
                                        options={
                                          Array.isArray(banks) &&
                                          banks.length > 0
                                            ? banks.map((bank) => ({
                                                value: bank.id,
                                                label: `${bank.bank_name} - A/C: ${bank.account_number}`,
                                                bank_name: bank.bank_name,
                                                account_number:
                                                  bank.account_number,
                                                ifsc_code: bank.ifsc_code,
                                                branch_name: bank.branch,
                                                bank_type: bank.type,
                                                org_name: bank.name,
                                                org_id: bank.org_id,
                                              }))
                                            : []
                                        }
                                        value={
                                          banks
                                            ?.map((bank) => ({
                                              value: bank.id,
                                              label: `${bank.bank_name} - A/C: ${bank.account_number}`,
                                            }))
                                            .find(
                                              (opt) =>
                                                opt.value === item.selected_bank
                                            ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          const updatedOrders = [...gridOrders];
                                          const updatedStatusArray = [
                                            ...statusArray,
                                          ];
                                          updatedOrders[index] = {
                                            ...updatedOrders[index],
                                            selected_bank:
                                              selectedOption?.value || "",
                                            bank:
                                              selectedOption?.bank_name || "",
                                            account_number:
                                              selectedOption?.account_number ||
                                              "",
                                            ifsc_code:
                                              selectedOption?.ifsc_code || "",
                                            branch_name:
                                              selectedOption?.branch_name || "",
                                            bank_type:
                                              selectedOption?.bank_type || "",
                                            org_name:
                                              selectedOption?.org_name || "",
                                            org_id:
                                              selectedOption?.org_id || "",
                                          };

                                          updatedStatusArray[index] = {
                                            ...updatedStatusArray[index],
                                            selected_bank:
                                              selectedOption?.value || "",
                                            bank:
                                              selectedOption?.bank_name || "",
                                            account_number:
                                              selectedOption?.account_number ||
                                              "",
                                            ifsc_code:
                                              selectedOption?.ifsc_code || "",
                                            branch_name:
                                              selectedOption?.branch_name || "",
                                            bank_type:
                                              selectedOption?.bank_type || "",
                                            org_name:
                                              selectedOption?.org_name || "",
                                            org_id:
                                              selectedOption?.org_id || "",
                                          };

                                          setGridOrders(updatedOrders);
                                          setStatusArray(updatedStatusArray);
                                        }}
                                        placeholder="--Select Bank--"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            minHeight: "36px",
                                            fontSize: "14px",
                                            zIndex: 5,
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          option: (base) => ({
                                            ...base,
                                            fontSize: "14px",
                                          }),
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <input
                                      readOnly
                                      className="form-control"
                                      type="text"
                                      value={
                                        isNaN(
                                          Number(
                                            item?.total_payable_net_off_tds
                                          )
                                        )
                                          ? (0.0).toFixed(2)
                                          : Number(
                                              item?.total_payable_net_off_tds
                                            ).toFixed(2)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      readOnly
                                      className="form-control"
                                      type="text"
                                      value={
                                        isNaN(
                                          Number(
                                            item?.total_payable_net_off_tds
                                          )
                                        )
                                          ? (0.0).toFixed(2)
                                          : Number(
                                              item?.total_payable_net_off_tds
                                            ).toFixed(2)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      readOnly
                                      className="form-control"
                                      type="text"
                                      value={Number(item?.tds).toFixed(1)}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      readOnly
                                      className="form-control"
                                      type="text"
                                      value={
                                        isNaN(
                                          Number(
                                            item?.amount_to_be_paid_net_off_tds
                                          )
                                        )
                                          ? (0.0).toFixed(2)
                                          : Number(
                                              item?.amount_to_be_paid_net_off_tds
                                            ).toFixed(2)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No Data Added
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2 pb-2">
                    {userDetails?.user_category === "Finance" ? (
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        {gridStatus !== "Rejected" &&
                          gridStatus !== "Paid" &&
                          workflowApprovalStatus === "Approved" && (
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              <label
                                htmlFor="payment-date"
                                className="form-label fw-bold me-2 mb-0"
                              >
                                Select Date:
                              </label>
                              <input
                                id="payment-date"
                                type="datetime-local"
                                className="form-control me-3"
                                style={{ width: "200px" }}
                                onChange={(e) => {
                                  const isoDate = new Date(
                                    e.target.value
                                  )?.toISOString();
                                  console.log(isoDate);
                                  setDateForPaid(isoDate);
                                }}
                              />

                              <div className="form-check form-check-inline align-items-center">
                                <input
                                  disabled={restrictedUser()}
                                  className="form-check-input"
                                  type="checkbox"
                                  id="mark-payment"
                                  checked={markAsPaid}
                                  onChange={(e) => {
                                    setMarkAsPaid(e.target.checked);
                                    setPaidSubmitFlag(e.target.checked);
                                  }}
                                />
                                <label
                                  htmlFor="mark-payment"
                                  className="form-check-label text-secondary ms-1"
                                >
                                  <h6 className="mb-0">Mark as Paid</h6>
                                </label>
                              </div>

                              <button
                                type="button"
                                className="btn btn-primary ayekart-fintech/grids-bg-4b589c px-3"
                                hidden={!paidSubmitFlag}
                                disabled={isSubmitDisabled}
                                onClick={submitMarkAsPaid}
                              >
                                Submit
                              </button>
                            </div>
                          )}

                        {gridStatus !== "Rejected" && gridStatus !== "Paid" && (
                          <button
                            type="button"
                            className="btn btn-danger px-3"
                            onClick={cancelGrid}
                            disabled={restrictedUser()}
                          >
                            Cancel Grid
                          </button>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Toaster />
      </div>
      {/* Modal to inform file sent to h2h path  */}
      <Modal
        className="rounded-md"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="p"
            component="p"
            className="fw-bolder flex justify-start"
          >
            {modalMessage}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}></Typography>
          <div className="flex justify-end mt-2">
            <Button
              variant="contained"
              onClick={handleCloseModal}
              style={{ backgroundColor: "#B20D40", color: "#fff" }}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default AyekartAgroFinanceGridView;
